import styled from 'styled-components'
import { Dropdown } from 'react-bootstrap'

export const Menu = styled(Dropdown.Menu)`
  width: 18.75rem;
  background-color: ${props => props.theme.colors.backgroundDropdown};
`
